export default "__VITE_ASSET__C1a9L7AD__"